import React from "react";
import style from  "./loginform.module.css";
import LTALogo from '../../../assets/img/lta_logo.png'
import {Box, Button, Divider, Grid, TextField, Typography} from "@material-ui/core";
import axios from "axios";
import get from "lodash/get";
import { getAccess } from "../constants";
import { connect } from "react-redux";
import { bindActionCreators,compose } from "redux";
import LoginService, {loginService} from '@app/common/services/loginservice'
import fileDownload from "js-file-download";
import classNames from 'classnames'
import moment from "moment"
import {
    loadAccess,
    loadLevel,
    setLoading,
    loadUser, loadSession, unloadSession, loadSessionExpired,
} from "@app/common/store/action";
import {  withRouter } from "react-router-dom";

import Axios from "axios";
import {getCookie} from "../../../helper/cookie";

import {
    LOG_SUC_200,
    LOG_SUC_201, LOG_SUC_202, LOG_SUC_203,

} from "@app/common/constants/constants";
import ErrorTextContainer from "../../../components/errortextcontainer/errortextcontainer";
import {
    FIRST_TIME_CHANGE_PASSWORD_ROUTE,
    FORGOT_PASSWORD_ROUTE,
    MFA_SETUP_ROUTE,
    MFA_VERIFICATION_ROUTE
} from "../../../constants/routeconstants";

import { LOGIN,OPERATOR} from "../../../constants/appconstants";

import {logoutService} from "@app/common/services/logoutservice";
import CustomButton from "../../../components/custombutton/custombutton";
import BANDownload from "../../../components/bandownlaod/bandownload";

class LoginForm extends React.Component {
    state = {
        userName: "",
        password: "",
        errorText: "",
        buttonDisabled: true,
        showDialog:false,
        title:'',
        subTitle:'',
        isTwoButtons:true,
    };



    componentDidMount() {
        // const state = get(this,"props.location.state",false)
        // const history = get(this,"props.history")
        // const fileDownload = get(state,"fileDownload")

        // if(fileDownload){
        //     this.setState({
        //         // showDialog:true,
        //         // isTwoButtons:true,
        //         // title:DOWNLOAD_TITLE,
        //         // subTitle:DOWNLOAD_SUB_TITLE
        //         startDownload:true
        //     })
        //     delete state.fileDownload;
        //    history.replace({ ...history.location, state })
        // }else{
            this.handleLogout()
        // }
    }
    handleLogout = async()=>{


        try{
            await logoutService()

        }catch(err){

        }


    }

    onSubmitHandler = async (e) => {
        e.preventDefault();

        const { userName, password } = this.state;
        const { actions } = this.props;

        actions.setLoading(true);
        try{
            let response = await loginService(userName.trim(),password.trim());
            let serviceResponseHeader = get(response,"serviceResponseHeader");
            let serviceResponseBody = get(response,"serviceResponseBody");
            let statusCode = get(serviceResponseHeader,"statusCode");
            let session = get(serviceResponseBody,"session");
            actions.setLoading(false);
            console.log("statusCode123",statusCode)
            console.log("","")
            actions.loadUser({
                userName: userName,
            });
            if (statusCode === LOG_SUC_200) {
                Axios.defaults.headers.common['X-CSRF-TOKEN'] =getCookie("iccd");
            } else if (statusCode === LOG_SUC_201) {
                Axios.defaults.headers.common['X-CSRF-TOKEN'] = getCookie("iccd");
                this.props.actions.loadSession(session)
                this.props.history.push({
                    pathname: FIRST_TIME_CHANGE_PASSWORD_ROUTE,
                    state: {
                        userName: userName,
                    },
                });
            }else if (statusCode === LOG_SUC_202){
                this.props.actions.loadSession(session)
                this.props.history.push(MFA_SETUP_ROUTE)
            }else if (statusCode === LOG_SUC_203){
                this.props.history.push(MFA_VERIFICATION_ROUTE)
            }
        }catch(e){
            actions.setLoading(false);
            this.setState({ errorText:e,userName: "",password: "", buttonDisabled:true});
        }
    };
    //on change of the input value
    onChangeHandler = (name) => (event) => {
        this.setState(
            {
                [name]: event.target.value,
                errorText: "",
            },
            () => {
                const { userName, password } = this.state;
                if (userName !== "" && password !== "") {
                    this.setState({ buttonDisabled: false });
                } else {
                    this.setState({ buttonDisabled: true });
                }
            }
        );
    };


    render() {
        const { buttonDisabled, errorText ,userName,password,showDialog,title,subTitle,isTwoButtons} = this.state;
        return (
             <form onSubmit={this.onSubmitHandler}>
                 <Grid container  direction={"column"}>
                     <Grid item >
                         <ErrorTextContainer text={errorText}/>
                     </Grid>
                     <Grid item className={classNames(style.login_form_text_field_container,style.login_form_text_field_spacing)} >
                         <TextField
                             required
                             id="outlined-required"
                             label="Username"
                             fullWidth
                             variant="outlined"
                             value={userName}
                             autoComplete={false}
                             onChange={this.onChangeHandler("userName")}
                         />
                     </Grid>

                     <Grid item className={style.login_form_text_field_container} >
                         <TextField
                             required
                             id="outlined-required"
                             label="Password"
                             fullWidth
                             autoComplete={false}
                             type="password"
                             value={password}
                             variant="outlined"
                             onChange={this.onChangeHandler("password")}
                         />

                     </Grid>

                     <Grid item>
                         <CustomButton
                             buttonDisabled={buttonDisabled}
                             title={LOGIN}
                         />
                     </Grid>
                     <Grid item className={style.login_form_forgot_password} onClick={()=>this.props.history.push(FORGOT_PASSWORD_ROUTE)}>
                         <Typography>
                             Forgot Password?
                         </Typography>

                     </Grid>
                 </Grid>
                 {/*<BANDownload startDownload={this.state.startDownload} type={OPERATOR}/>*/}

             </form >
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    access: state.access,
});

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            { loadAccess, loadLevel, setLoading, loadUser ,loadSession},
            dispatch
        ),
    };
}

export default compose(connect(mapStateToProps, mapDispatchToProps),withRouter)(LoginForm);



